import SleepingCompanions from "../../assets/imgs/sleeping-companions.svg";

export const CompanionDownstate = () => {
  return (
    <div
      className="flex flex-1 flex-col h-full w-full"
      data-testid="companion-downstate"
    >
      <div className="rounded-xl bg-primary flex flex-1 items-center justify-center p-md text-primary overflow-hidden">
        <div className="flex w-full flex-col items-center gap-md text-center">
          <img
            src={SleepingCompanions}
            alt="The Companions are sleeping"
            className="w-full h-auto max-w-2xl"
          />
          <h4 className="text-base font-companion">
            The Companions are sleeping...
          </h4>
          <h5 className="text-sm text-placeholder font-companion">
            Companion is unavailable right now. Please check back
            later.
          </h5>
        </div>
      </div>
    </div>
  );
};
